var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrevIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.707 7.29279C14.8945 7.48031 14.9998 7.73462 14.9998 7.99979C14.9998 8.26495 14.8945 8.51926 14.707 8.70679L11.414 11.9998L14.707 15.2928C14.8892 15.4814 14.99 15.734 14.9877 15.9962C14.9854 16.2584 14.8803 16.5092 14.6948 16.6946C14.5094 16.88 14.2586 16.9852 13.9964 16.9875C13.7342 16.9897 13.4816 16.8889 13.293 16.7068L9.29303 12.7068C9.10556 12.5193 9.00024 12.265 9.00024 11.9998C9.00024 11.7346 9.10556 11.4803 9.29303 11.2928L13.293 7.29279C13.4806 7.10532 13.7349 7 14 7C14.2652 7 14.5195 7.10532 14.707 7.29279V7.29279Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrevIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prev-icon.16bc458bf4c857883194ded74374a66f.svg";